import styled from 'styled-components'
import { stylevars } from '@Common/StyleVars'

export const StyledModalContainer = styled('div')`
`